import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EnvironmentServiceProvider } from 'src/app/providers/environment.service.provider'
import { AppRoutingModule } from './app-routing.module'
import { SharedModule } from './modules/shared/shared.module'
// pipes
import { NgHttpLoaderModule } from 'ng-http-loader';

@NgModule({
  declarations: [
    AppComponent   
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    NgHttpLoaderModule.forRoot()
  ],
  providers: [EnvironmentServiceProvider],
  bootstrap: [AppComponent]
})
export class AppModule { }
